import { getButtonClasses } from '@nautilusbio/nb-design-system/Button';
import { clsx } from 'clsx';

import styles from './styles.module.css';

// For the footer's non-Button rows (a Link, an anchor) only. A real Button re-runs
// getButtonClasses over whatever className it is handed, so passing this to one emits the base,
// size and visual classes twice and smuggles fullWidth in as a class instead of a prop.
const sidebarLinkClassName = clsx(
  styles.sidebarLink,
  getButtonClasses({
    fullWidth: true,
    visual: 'unstyled',
  }),
);

export { sidebarLinkClassName };
